import { triggerHostMessageHideThirdPartyWidget } from '../triggerHostMessage/triggerHostMessageHideThirdPartyWidget';
export default function hideThirdPartyWidgetHandler(data) {
  triggerHostMessageHideThirdPartyWidget(data);
}